import { createFileRoute } from "@tanstack/react-router";
import { useTranslation } from "react-i18next";

export const Route = createFileRoute("/participate/done")({
  component: ParticipantDone,
});

function ParticipantDone() {
  const { t } = useTranslation();
  return (
    <div className="max-w-[36rem] p-8 md:p-4">
      <p className="mb-4 text-[1.5rem] font-medium">{t("participation_thank_you")}</p>
      <p>{t("rest_of_session_on_big_screen")}</p>
    </div>
  );
}
